import { useNavigate } from 'react-router-dom';

/* University → Tests: the tests an admin has unlocked for this person.
   Nothing shows until an admin unlocks it. The Closer Profile disappears once submitted. */

const CSS = `
.mt-list{display:flex;flex-direction:column;gap:14px;margin-top:20px;max-width:720px}
.mt-card{background:#fff;border:2px solid #DCE6E1;border-radius:16px;padding:18px 20px;display:flex;gap:16px;align-items:center;flex-wrap:wrap}
.mt-card.open{border-color:#1f5b3a;box-shadow:0 10px 24px -16px rgba(13,59,46,.55)}
.mt-ic{font-size:34px;line-height:1}
.mt-body{flex:1;min-width:200px}
.mt-body h3{margin:0;font-size:1.12rem;font-weight:800;color:#12281F}
.mt-body p{margin:3px 0 0;font-size:.88rem;color:#5a685f}
.mt-pill{display:inline-block;font-size:.72rem;font-weight:800;letter-spacing:.05em;text-transform:uppercase;padding:3px 9px;border-radius:99px;margin-top:6px;margin-right:6px}
.mt-pill.new{background:#FFF3D6;color:#8A5A00}.mt-pill.pass{background:#e2f2e9;color:#1f7a4a}.mt-pill.fail{background:#f9e5e3;color:#b3362c}.mt-pill.info{background:#EEF3F0;color:#4A5D55}
.mt-btn{font:inherit;font-weight:800;border:0;border-radius:10px;padding:11px 18px;background:#1f5b3a;color:#fff;cursor:pointer}
.mt-btn.ghost{background:#fff;color:#1f5b3a;border:1.5px solid #1f5b3a}
`;

export default function MyTests({ tests }) {
  const navigate = useNavigate();
  const go = (key, review) => navigate(`/training/test/${key}${review ? '?review=1' : ''}`);
  return (
    <div className="mt-list">
      <style>{CSS}</style>
      {tests.map(t => {
        const exam = t.kind === 'exam';
        const canTake = t.status === 'open' || t.status === 'retry';
        return (
          <div key={t.key} className={'mt-card' + (canTake ? ' open' : '')}>
            <div className="mt-ic" aria-hidden>{exam ? '📝' : '🧭'}</div>
            <div className="mt-body">
              <h3>{t.title}</h3>
              <p>{t.blurb}</p>
              {t.status === 'open' && <span className="mt-pill new">Unlocked · ready to start</span>}
              {exam && t.last && <span className={'mt-pill ' + (t.last.passed ? 'pass' : 'fail')}>Last try: {t.last.score} / {t.last.total} · {t.last.passed ? 'Passed' : 'Not passed'}</span>}
              {exam && t.used > 0 && <span className="mt-pill info">{t.left > 0 ? `${t.left} ${t.left === 1 ? 'try' : 'tries'} left` : 'No tries left · ask your manager'}</span>}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {exam && t.last && <button className="mt-btn ghost" onClick={() => go(t.key, true)}>See results</button>}
              {canTake && <button className="mt-btn" onClick={() => go(t.key)}>{t.status === 'retry' ? 'Try again' : 'Start'}</button>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
